import config from "../config";
import request, { requestOptions } from "../utils/request";

const baseUrl = `${config.API_ROOT}`;

const Teams = {
  async createInvite(body) {
    const options = await requestOptions("POST", body, true);
    const url = `${baseUrl}/team`;
    return request(url, options);
  },
  async getInvite() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/team`;
    return request(url, options);
  },
  async removeInvite({ id }) {
    const options = await requestOptions("PUT", {}, true);
    const url = `${baseUrl}/team/${id}`;
    return request(url, options);
  },
  async updateUserRole({ id, role }) {
    const options = await requestOptions("PUT", { role }, true);
    const url = `${baseUrl}/team/${id}/role`;
    return request(url, options);
  },
};

export default Teams;
